import { observer } from "mobx-react-lite";

import { IconChatAttention } from "@synthesis/shared-icons";
import { Button, Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

import { useStores } from "../../store";

const MarkupButton = observer(({ onClick }: { onClick?: () => void }) => {
  const { generalStore } = useStores();

  return (
    <Tooltip arrowSide="bottom" description="Замечания">
      <Button
        theme="text"
        disabled={generalStore.checkedFiles.size !== 1}
        onClick={onClick}
        leftIcon={
          <IconChatAttention
            data-cy="markupButton-iconChatAttention"
            className={cn("size-5", generalStore.checkedFiles.size !== 1 && "text-[#d0c6c3]")}
          />
        }
      />
    </Tooltip>
  );
});

export default MarkupButton;
